// extracted by mini-css-extract-plugin
export var bubble = "_2r-0";
export var container = "_2r-f";
export var contrastBorder = "_2r-g";
export var greyOut = "_2r-2";
export var initialsColor0 = "_2r-3";
export var initialsColor1 = "_2r-4";
export var initialsColor10 = "_2r-d";
export var initialsColor11 = "_2r-e";
export var initialsColor2 = "_2r-5";
export var initialsColor3 = "_2r-6";
export var initialsColor4 = "_2r-7";
export var initialsColor5 = "_2r-8";
export var initialsColor6 = "_2r-9";
export var initialsColor7 = "_2r-a";
export var initialsColor8 = "_2r-b";
export var initialsColor9 = "_2r-c";
export var initialsWrapper = "_2r-1";
export var large = "_2r-l";
export var medium = "_2r-k";
export var mediumSmall = "_2r-j";
export var mediumSmallMedium = "_2r-o";
export var micro = "_2r-h";
export var small = "_2r-i";
export var tiny = "_2r-n";
export var xTiny = "_2r-m";